import React, { useContext, useState } from "react";
import _ from "lodash";

import { Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import EnvironmentDisplay from "./Logo/EnvironmentDisplay";
import VersionDisplay from "./Logo/VersionDisplay";
import { kioskstyles } from "./../../../kioskstyles";

import SocketIOContext from "../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../env");

// props has activeStep
export default function Logo(props) {
  //const theme = useTheme();
  const { getKioskTheme } = useContext(SocketIOContext);

  const [loading, setLoading] = useState(true);
  const [errorLoading, setErrorLoading] = useState(false);

  const kioskTheme = getKioskTheme();

  let environment_text = env.REACT_APP_ENV;
  if (env.REACT_APP_ENV == "PROD") {
    environment_text = "";
  }

  return (
    <div
      style={{
        //maxWidth: "700px"
        alignSelf: "flex-start"
      }}
    >
      {/* <Typography
        variant="body2"
        style={{
          color: "yellow",
          //marginTop: theme.spacing(5),
          // paddingRight: "clamp(0px, 27vw, 416px)",
          //paddingRight: "clamp(0px, 27vw, 446px)",
          fontSize: "clamp(12px, 3vw, 36px)",
          //height: "10px",
          fontWeight: "bold",
          //position: "relative",
          top: "0px",
          left: "0px"
        }}
      >
        {environment_text}
      </Typography> */}
      <EnvironmentDisplay />
      {/* <img
        src="/img/consignaction-logo-cropped.png"
        style={{
          width: "80%",
          position: "relative",
          top: "0px",
          left: "0px"
        }}
        alt="Consignaction Logo"
      ></img>
      <VersionDisplay />
    </div> */}
      {errorLoading || (kioskTheme.headerLogoPath && loading) ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          width: "80%",
          position: "relative",
          top: "0px",
          left: "0px",
          display: loading ? "hidden" : "block",
          aspectRatio: "1693 / 227"
          //backgroundColor: "red"
        }}
      >
        <img
          src={
            // kioskTheme.headerLogoPath
            //   ? env.REACT_APP_API_ENDPOINT + "/kiosk/getHeaderLogo"
            //   : "/img/consignaction-logo-cropped.png"
            env.REACT_APP_API_ENDPOINT +
            "/kiosk/getImage/HeaderLogo1" +
            "?t=" +
            kioskTheme.lastUpdatedImgETag
          }
          onLoad={() => {
            setLoading(false);
            setErrorLoading(false);
          }}
          onError={e => {
            // if (e.target.src !== fallbackImagePath) {
            //   e.target.src = fallbackImagePath;
            // }
            setErrorLoading(true);
          }}
          style={{
            width: "auto",
            //height: "100%",
            //maxWidth: "100%"
            //height: "7.8vh",
            maxHeight: "7.8vh",
            //maxWidth:"800px"  //Match parent Panel
            maxWidth: "610px" //610px for horizontal. Seems to work for vertical as well
          }}
          alt="Consignaction Logo"
        ></img>
      </div>

      <VersionDisplay />
    </div>
  );
}
